'use strict'
exports.__esModule = true
exports.default = new Promise(function (resolve, reject) {
  try {
    const script = document.getElementById('_uasdk')
    const rel = script && script.rel

    if (!rel) {
      reject(new Error('unable to locate airship sdk on the window'))
      return
    }

    resolve(window[rel])
  } catch (e) {
    reject(e)
  }
})
